window.notify = function(message, type) {
    $.notify({
        message: message
    }, {
        type: type,
        allow_dismiss: true,
        label: 'Отказ',
        className: 'btn-xs btn-inverse',
        placement: {
            from: 'top',
            align: 'right'
        },
        delay: 2500,
        animate: {
            enter: 'animated fadeInRight',
            exit: 'animated fadeOutRight'
        },
        offset: {
            x: 50,
            y: 50
        }
    });
};


// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/bootstrap-notify-init.js